<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类管理
    -->
  <div class="product">
    <div style='margin-bottom:20px;border:1px solid pink;border-radius: 4px;'>
      <el-alert title="注意：" :closable="false" type="warning" show-icon>
        <template #title>
          <div style='margin:10px 20px '>
            <p>
              报警信息是指在发生紧急情况时，向公安机关或其他相关部门报告事件的文字信息。这些信息通常包括事件的时间、地点、情况描述，等详细信息。重要的是要提供尽可能多的详细信息，并保持清晰和简洁。这将有助于公安机关或其他相关部门更快地了解事件情况，并采取适当的措施来处理紧急情况。 在本系统中，报警存在两种情况。
            </p>
            <p style='margin-top:10px;color:#3a8ee6'>
              预警页面：<br> 1.首页报警：技师当前不在服务客人的时候，点击了我们app 中的报警进行的报警。
              <br> 2.订单页报警：技师当前处于服务中，点击了我们app中的报警。
            </p>
          </div>
        </template>

      </el-alert>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="技师电话">
          <el-input size="small" v-model="searchForm.phone" placeholder="请输入技师电话"></el-input>
        </el-form-item>
        <el-form-item label="所属商户">
          <el-select size="small" v-model="searchForm.shopSupplierId" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in SupplierData" :key="index" :label="item.name" :value="item.shopSupplierId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="警报时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.search_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" :default-sort="{prop: 'id', order: 'descending'}" border default-expand-all :tree-props="{children: 'child'}" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" sortable label="ID" width="100"></el-table-column>
          <!-- <el-table-column prop="image" label="技师头像" width="180">
            <template slot-scope="scope">
              <img :src='scope.row.image' alt="" width="50px" height="50px" />
            </template>
          </el-table-column> -->
          <el-table-column prop="waiter_user_id" align="center" label="技师ID">
          </el-table-column>
          <el-table-column prop="" align="center" label="技师姓名">
            <template slot-scope="scope">
              {{scope.row.waiter?scope.row.waiter.username:'暂无'}}
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="电话">
            <template slot-scope="scope">
              {{scope.row.waiter?scope.row.waiter.mobile:'暂无'}}
            </template>
          </el-table-column>
          <el-table-column prop="service_address" align="center" label="报警位置"></el-table-column>
          <el-table-column prop="type.text" align="center" label="报警类型"></el-table-column>

          <el-table-column prop="is_deal" align="center" label="状态">
            <template slot-scope="scope">
				<el-tag v-if='scope.row.is_deal && scope.row.is_deal.value== 0' type="danger">未处理</el-tag>
				<el-tag v-else-if='scope.row.is_deal && scope.row.is_deal.value==1' type="success">已处理</el-tag>
				<el-tag v-else-if='scope.row.is_deal && scope.row.is_deal.value==2' type="info">已取消</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="所属商户">
            <template slot-scope="scope">
              {{scope.row.supplier?scope.row.supplier.name:'暂无'}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" align="center" label="报警时间"></el-table-column>
          <el-table-column prop="word" align="center" label="备注"></el-table-column>
          <el-table-column prop="deal_time" align="center" label="审阅时间"></el-table-column>
          <el-table-column prop="deal_user" align="center" label="审阅人"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" :disabled="scope.row.is_deal.value==1" align="center" type="primary" size="small">审阅</el-button>
              <!-- <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/order/callmsg/delete'">删除</el-button> -->
              <!-- <el-button @click="deleteClick(scope.row)" type="text" size="small">详情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="dealModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="categoryModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import CallmsgApi from "@/api/callmsg.js";
import Add from "./Add.vue";
import Edit from "./Edit.vue";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*当前编辑的对象*/
      SupplierData: [],
      dealModel: {},
      searchForm: {
        supplier_user_id: "",
        search_time: "",
        phone: ""
      }
    };
  },
  created() {
    /*获取商户*/
    this.getSupplier();
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*获取所有商户*/
    getSupplier() {
      let self = this;
      CallmsgApi.getSupplier({}, true)
        .then(data => {
          console.log('商户列表', data.data)
          self.loading = false;
          self.SupplierData = data.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      CallmsgApi.callLog(Params, true)
        .then(data => {
          console.log(data.data)
          self.loading = false;
          self.tableData = data.data.result.data;
          self.totalDataNumber = data.data.result.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*打开添加*/
    addClick(item) {
      this.dealModel = item;
      this.open_add = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.categoryModel.model = item;
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*删除分类*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          CallmsgApi.ServiceTypeDel({
            id: row.id
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/callmsg/index.vue